export default __webpack_public_path__ + "static/media/shirt2.597eafc0.jpeg";